import React from 'react';
import T from 'prop-types';

import EmailConfirmationModal from './subcomponents/emailConfirmationModal';
import ForgotPasswordModal from './subcomponents/forgotPasswordModal';
import LoginModal from './subcomponents/loginModal';
import PasswordResetModal from './subcomponents/passwordResetModal';
import ResendEmailConfirmationModal from './subcomponents/resendEmailConfirmationModal';
import SignupModal from './subcomponents/signupModal';

const AuthModals = ({ isAuthenticated }) => {
  if (isAuthenticated) {
    return <PasswordResetModal />;
  }

  return (
    <>
      <SignupModal />
      <LoginModal />
      <ForgotPasswordModal />
      <EmailConfirmationModal />
      <PasswordResetModal />
      <ResendEmailConfirmationModal />
    </>
  );
};

AuthModals.propTypes = {
  isAuthenticated: T.bool.isRequired,
};

export default AuthModals;
